'use strict';

const {
    PHOTO_UI_UPDATE_DIMENSIONS,
    PHOTO_UI_SHOW_ITEM_TAGS,
    PHOTO_UI_HIDE_ITEM_TAGS,
    PHOTO_UI_SET_ITEM_TAG,
    PHOTO_UI_UNSET_ITEM_TAG
} = require('../actions/galleryActionConstants');

const isNumber = n => typeof n === 'number';

const GalleryPhotoUIStore = {
    storeName: 'GalleryPhotoUIStore',
    initialState: {
        // item tag state
        showItemTags: false,
        activeItemTag: void 0,

        imageDimensions: {
            width: 0,
            height: 0
        }
    },

    reducers: {
        [PHOTO_UI_UPDATE_DIMENSIONS](state, {width, height} = {}) {
            if (isNumber(width) && isNumber(height)) {
                return Object.assign({}, state, {
                    imageDimensions: Object.assign({}, state.imageDimensions, {
                        width, height
                    })
                });
            }
            return state;
        },
        [PHOTO_UI_SET_ITEM_TAG](state, activeItemTag) {
            if (activeItemTag) {
                state = Object.assign({}, state, {
                    activeItemTag
                });
            }
            return state;
        },
        [PHOTO_UI_UNSET_ITEM_TAG](state) {
            if (state.activeItemTag) {
                state = Object.assign({}, state, {
                    activeItemTag: void 0
                });
            }
            return state;
        },
        [PHOTO_UI_SHOW_ITEM_TAGS](state) {
            if (!state.showItemTags) {
                state = Object.assign({}, state, {
                    showItemTags: true
                });
            }
            return state;
        },
        [PHOTO_UI_HIDE_ITEM_TAGS](state) {
            if (state.showItemTags) {
                state = Object.assign({}, state, {
                    showItemTags: false
                });
            }
            return state;
        }
    },

    getters: {
        getImageDimensions(state) {
            return state.imageDimensions;
        },

        getItemTagsState(state) {
            return {
                showItemTags: state.showItemTags,
                activeItemTag: state.activeItemTag
            };
        }
    }
};

module.exports = GalleryPhotoUIStore;



// WEBPACK FOOTER //
// ./assets/js/gallery/stores/GalleryPhotoUIStore.es.js